import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Wait for the page to render then scroll to the element
      const id = location.hash.replace("#", "");
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) {
          const headerOffset = 90;
          const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
          window.scrollTo({ top, behavior: "smooth" });
        }
      };
      // Small delay to allow content to mount
      setTimeout(scroll, 120);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen flex flex-col bg-bone text-ink" data-testid="site-layout">
      <Header />
      <main className="flex-1" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
